module.exports = __webpack_public_path__ + "img/SummerOfPride2020_Mobile.3ec04306.jpg";